import { supabase } from './supabase';

const VISITOR_KEY = 'kairos_visitor_key';
const SESSION_KEY = 'kairos_session_key';
const SOURCE_KEY = 'kairos_source';
const TRACKED_KEY = 'kairos_tracked_visit_key';

function randomKey(prefix) {
  const rand = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}-${rand}`;
}

export function getOrCreateVisitorKey() {
  let value = localStorage.getItem(VISITOR_KEY);
  if (!value) {
    value = randomKey('visitor');
    localStorage.setItem(VISITOR_KEY, value);
  }
  return value;
}

export function getOrCreateSessionKey() {
  let value = sessionStorage.getItem(SESSION_KEY);
  if (!value) {
    value = randomKey('session');
    sessionStorage.setItem(SESSION_KEY, value);
  }
  return value;
}

function sourceFromReferrer(referrer) {
  const value = String(referrer || '').toLowerCase();
  if (!value) return 'direct';
  if (value.includes('linkedin')) return 'linkedin';
  if (value.includes('whatsapp') || value.includes('wa.me')) return 'whatsapp';
  if (value.includes('facebook')) return 'facebook';
  if (value.includes('instagram')) return 'instagram';
  if (value.includes('google')) return 'google';
  return 'referral';
}

export function getStoredSource() {
  const params = new URLSearchParams(window.location.search);
  const explicit = params.get('utm_source') || params.get('source') || params.get('ref');
  if (explicit) {
    localStorage.setItem(SOURCE_KEY, explicit.toLowerCase());
    return explicit.toLowerCase();
  }

  const saved = localStorage.getItem(SOURCE_KEY);
  if (saved) return saved;

  const detected = sourceFromReferrer(document.referrer);
  localStorage.setItem(SOURCE_KEY, detected);
  return detected;
}

export async function trackAppVisit(userId) {
  const visitorKey = getOrCreateVisitorKey();
  const sessionKey = getOrCreateSessionKey();
  const source = getStoredSource();
  const trackedVisitKey = `${sessionKey}:${userId || 'anon'}`;

  if (sessionStorage.getItem(TRACKED_KEY) === trackedVisitKey) return;

  const { data: { session } } = await supabase.auth.getSession();
  const API_BASE = import.meta.env.VITE_API_BASE || '';
  const response = await fetch(`${API_BASE}/api/analytics/visit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
    },
    body: JSON.stringify({ visitorKey, sessionKey, source }),
  });

  if (response.ok) {
    sessionStorage.setItem(TRACKED_KEY, trackedVisitKey);
  }
}

export async function trackPageView(page) {
  const visitorKey = getOrCreateVisitorKey();
  const sessionKey = getOrCreateSessionKey();

  try {
    const { data: { session } } = await supabase.auth.getSession();
    const API_BASE = import.meta.env.VITE_API_BASE || '';
    await fetch(`${API_BASE}/api/analytics/page-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
      },
      body: JSON.stringify({ visitorKey, sessionKey, page }),
    });
  } catch {
    // silent — tracking must never break the app
  }
}
